module.exports = __webpack_public_path__ + "static/media/kbcgif.0634ec2b.gif";